import './main.less';
import React from 'react';
import PropTypes from 'prop-types';
import { reduxForm, Field, FieldArray } from 'redux-form';
import { connect } from 'react-redux';
import cn from 'classname';
import noop from 'lodash/noop';
import find from 'lodash/find';
import _xor from 'lodash/xor';
import findIndex from 'lodash/findIndex';
import isEmpty from 'lodash/isEmpty';
import filter from 'lodash/filter';
import get from 'lodash/get';
import some from 'lodash/some';
import { Link } from 'react-router';

import CheckboxField from '../../../../../shared/form-elements/checkbox';
import SelectField from '../../../../../shared/form-elements/select/field';
import InputField from  '../../../../../shared/form-elements/input';

import { getFiltersObject } from '../../../../../shared/filters';
import Filters from '../../../../../shared/filters/main';

import dashboard from '../../../../../../config/dashboard';

import AddField from './add-field';
import Entity from './entity';
import Targets from './targets';

const isRocket = process.env.CPA_ENV === 'rocket';

const Form = (props) => (
	<div className="individual-terms">
		<div className="clearfix">
			<Filters {...props} filters={props.individualTermsFilters} {...props.individualTermsFilters} />
		</div>

		<form action="" className="ui-form" onSubmit={props.handleSubmit(data => props.prepareTermsFormSubmit(data))}>
			<FieldArray
				filters={getFiltersObject(props.individualTermsFilters)}
				name="terms"
				{...props}
				component={RenderFieldArrayContainer}
			/>
			<div className="ui-form__element individual-terms__buttons-wrap">
				<button className="ui-btn ui-btn-primary">{props.intl('Save')}</button>
			</div>
		</form>
	</div>
);

class RenderFieldArrayContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { openedOfferCampaigns: []};
		this.toggleOfferCampaigns = this.toggleOfferCampaigns.bind(this);
	}

	toggleOfferCampaigns(offer_id) {
		this.setState(state => ({
			openedOfferCampaigns: _xor([...state.openedOfferCampaigns], [offer_id])
		}));
	}

	render() {
		return (
			<RenderFieldArray
				toggleOfferCampaigns={this.toggleOfferCampaigns}
				selectedGeoId={get(this.props, 'filters.country_ids[0]')}
				{...this.props}
				{...this.state}
			/>
		);
	}
}

function renderOffersByOneGeoTable({ intl, selectedGeoId: locationId, isMaster, fields, ...props }) {
	return (
		<table className='offers-by-one-geo-table'>
			<thead>
				<tr>
					{isMaster && (
						<th className='locked' />
					)}
					<th className='offer'>Offers</th>
					<th className='geo'>Geo</th>
					<th className='cap'>Cap</th>
					<th className='max-payout'>Max aff payout</th>
					<th className='payout'>Payout, usd</th>
					<th className='actions' />
				</tr>
			</thead>
			<tbody>
				{fields.map((name, index) => {
					const field = fields.get(index);

					const offerId = get(field, 'offer[0].value');
					const targets = field.targets || [];

					if (!offerId) {
						return (
							<tr key={`payout:${index}`}>
								{isMaster && (
									<td className='locked' />
								)}
								<td className='offer'>
									<Field
										name={`${name}.offer`}
										placeholder={intl('Select offer')}
										component={SelectField}
										showLabel={false}
										multi={false}
										onChange={(entity) => props.fetchOfferDefaultTarget(index, entity[0])}
										options={props.offersLookups}
									/>
								</td>
								<td colSpan={4} />
								<td className='actions'>
									<div>
										<a
											className='delete'
											title='Delete'
											href='#'
											onClick={(e) => {
												e.preventDefault();
												fields.remove(index);
											}}
										/>
									</div>
								</td>
							</tr>
						);
					}

					const targetIndex = findIndex(targets, (target) => {
						return target.status === 'active' && target.location_id[0].value === locationId;
					});

					if (targetIndex === -1) {
						return null;
					}

					const payout = targets[targetIndex];

					const offer = find(props.offers, { id: offerId });

					const basePayout = offer ? find(offer.base_payouts, { location_id: locationId, currency: 'usd' }) : payout;

					const competencePercent = parseFloat(basePayout.competence_percent) || 0;
					const defaultAmount = parseFloat(basePayout.amount) || 0;

					const isCurrentlyBoosted = !find(props.nullifiedBoosts, { offerId, locationId })
						&& payout.boost_till !== null;

					const sidPayouts = filter(props.campaignPayouts, (cp) => {
						return cp.offer_id === offerId && cp.campaign_country_id === locationId && !!cp.sid;
					});

					return [
						<tr
							className={cn(payout.is_locked && 'locked-row')}
							key={`payout:${index}`}
						>
							{isMaster && (
								<td className='locked'>
									<Field
										name={`${name}.targets[${targetIndex}].is_locked`}
										component={CheckboxField}
										normalize={Boolean}
									/>
								</td>
							)}
							<td className='offer'>
								<Field
									name={`${name}.offer`}
									placeholder={intl('Select offer')}
									component={SelectField}
									showLabel={false}
									disabled={!!props.savedTerms[index]}
									multi={false}
									onChange={(entity) => props.fetchOfferDefaultTarget(index, entity[0])}
									options={props.offersLookups}
								/>
							</td>
							<td className='geo'>
								<Field
									name={`${name}.targets[${targetIndex}].location_id`}
									placeholder=''
									searchable={false}
									component={SelectField}
									showLabel={false}
									disabled
									multi={false}
									options={[]}
								/>
							</td>
							<td className='cap'>
								<Field
									name={`${name}.targets[${targetIndex}].cap`}
									placeholder=''
									component={InputField}
									showLabel={false}
								/>
							</td>
							<td className='max-payout'>
								<InputField
									showLabel={false}
									meta={{}}
									disabled
									input={{
										value: Math.round((100 + competencePercent) * defaultAmount / 100)
									}}
								/>
							</td>
							<td className={cn('payout', {
								more: payout.usd > defaultAmount,
								less: payout.usd < defaultAmount
							})}>
								<Field
									name={`${name}.targets[${targetIndex}].usd`}
									placeholder=''
									component={InputField}
									onChange={() => props.indTermsNullifyBoostOnSubmit({
										locationId,
										payoutPath: `${name}.targets[${targetIndex}].usd`,
										isBoosted: isCurrentlyBoosted,
										offerId
									})}
									showLabel={false}
								/>
							</td>
							<td className='actions'>
								<div>
									<a
										className='copy'
										title='Copy'
										href='#'
										onClick={(e) => {
											e.preventDefault();
											navigator.clipboard.writeText(`${dashboard.baseURL}/offers/${offerId}`);
										}}
									/>
								</div>
							</td>
						</tr>,
						<FieldArray
							name={`${name}.targets[${targetIndex}].campaigns`}
							defaultAmount={defaultAmount}
							payout={payout} // for rerender
							component={CampaignPayouts}
							key={`campaigns:${index}`}
						/>
					].concat(!sidPayouts.length ? [] : (
						<tr key={`sid-payout:${index}`}>
							<td colSpan={7}>
								<table className='sub-table'>
									<tbody>
										{sidPayouts.map((sp, i) => (
											<tr key={i}>
												<td />
												<td className='campaign'>
													<Link
														to={`campaigns/${sp.campaign_id}/payout-editor`}
														target='_blank'
													>
														<div className='block'>
															Campaign: {sp.campaign_id}
														</div>
													</Link>
												</td>
												<td className='geo'>
													<div className='block'>
														{sp.campaign_country}
													</div>
												</td>
												<td className='sid'>
													<div className='block'>
														<input readOnly value={`${sp.sid_type || 'sid'} (${sp.sid})`} />
													</div>
												</td>
												<td className={cn('payout', {
													more: sp.usd_amount > defaultAmount,
													less: sp.usd_amount < defaultAmount
												})}>
													<Link
														to={`campaigns/${sp.campaign_id}/payout-editor`}
														target='_blank'
													>
														<div className='block'>
															{sp.usd_amount}
														</div>
													</Link>
												</td>
												<td className='actions' />
											</tr>
										))}
									</tbody>
								</table>
							</td>
						</tr>
					));
				}).reverse()}
			</tbody>
		</table>
	);
}

function CampaignPayouts({ fields, defaultAmount }) {
	return !!fields.length && (
		<tr>
			<td colSpan={7}>
				<table className='sub-table'>
					<tbody>
						{fields.map((name, i) => {
							const cp = fields.get(i);

							return (
								<tr key={i}>
									<td />
									<td className='campaign'>
										<div className='block'>
											Campaign: {cp.campaign_id}
										</div>
									</td>
									<td className='geo'>
										<div className='block'>
											{cp.campaign_country}
										</div>
									</td>
									<td className='offset' />
									<td className={cn('payout', {
										more: cp.usd_amount > defaultAmount,
										less: cp.usd_amount < defaultAmount
									})}>
										<Field
											name={`${name}.usd_amount`}
											placeholder=''
											component={InputField}
											showLabel={false}
										/>
									</td>
									<td className='actions'>
										<div>
											<a
												className='delete'
												title='Delete'
												href='#'
												onClick={(e) => {
													e.preventDefault();

													if (confirm(`Do you realy want to delete payout for campaign: ${cp.campaign_id}?`)) {
														fields.remove(i);
													}
												}}
											/>
										</div>
									</td>
								</tr>
							);
						})}
					</tbody>
				</table>
			</td>
		</tr>
	);
}

const RenderFieldArray = (props) => (
	<div className="entity-wrap">
		<AddField
			disabled={shouldDisabledAddField(props.fields.getAll())}
			onClick={() => props.fields.push({})}
			intl={props.intl}
		/>

		{props.fields.length > 0 && (isRocket && props.selectedGeoId) ? renderOffersByOneGeoTable(props) : (
			<table className="entity-wrap__table">
				<thead className="entity-wrap__table-head">
					<tr>
						<th className="name">Offers</th>
						<th className="geo">Geo</th>
						<th className="payout">Payout</th>
						<th className="currencies"/>
						<th className="actions" />
					</tr>
				</thead>
				<tbody className="entity-wrap__table-body">
					{ (props.fields.map((parentName, index, fields) => {
						const field = props.fields.get(index);

						const collapsed = !!props.filters.country_ids && !!field.targets && !field.targets.some((target) => {
							return (props.filters.country_ids || []).includes(target.location_id[0].value)
								&& target.status === 'active';
						});

						const res = [];
						const shouldShowTarget = props.listOfActivePanIndex.indexOf(index) > -1 && !collapsed;
						const onToggleTargetPan = props.savedTerms[index]
							? shouldShowTarget
								? props.termsHideTargets
								: handleTermsShowTarget(
									props.savedTerms[index],
									props.termsShowTargets,
									props.fetchOfferDefaultTarget
								)
							: noop;

						// offers row
						res.push(<Entity
							className={cn({
								'individual-terms-collapsed': collapsed,
								'is-show-target': shouldShowTarget,
								'modify-cursor-pointer': props.initialValues.terms[index],
								'has-individual-terms': highlightOfferWithIndividualTerms(field)
							})}
							type='offer'
							parentName={parentName}
							index={index}
							intl={props.intl}
							placeholder={props.intl('Select offer')}
							entityLookup={props.offersLookups}
							savedTerms={props.savedTerms}
							fields={props.fields}
							selectedCurrenciesPanIndexMap={props.selectedCurrenciesPanIndexMap}
							onRemoveField={props.removeTerms}
							onToggleTargetPan={onToggleTargetPan}
							onFetchDefaultTarget={props.fetchOfferDefaultTarget}
							onChangeCurrency={props.changeIndTermCurrency}
							payoutCurrencies={props.payoutCurrencies}
							onDeleteOffers={props.deleteOffers}
							isMaster={props.isMaster}/>);
						if (props.campaignPayouts && props.campaignPayouts.length) {
							const offer_id = get(field, 'offer[0].value');

							const sidPayouts = props.campaignPayouts
								.filter(cpt => Number(cpt.offer_id) === Number(offer_id))
								.filter(cpt => !!cpt.sid);
							let needModifyBg = true;

							if (sidPayouts.length && !collapsed) {
								res.push(
									<tr>
										<td>
											<span
												onClick={props.toggleOfferCampaigns.bind(null, offer_id)}
												className="expand-campaigns-button hover-pointer"
											>
												{ props.openedOfferCampaigns.includes(offer_id) ? '-' : '+'}
											</span>
										</td>
									</tr>
								);
							}

							if (!collapsed) {
								for (const sp of sidPayouts) {
									needModifyBg = !needModifyBg;

									if (!props.openedOfferCampaigns.includes(offer_id)) {
										continue;
									}

									res.push(<tr className={cn({ 'modify-row-background': needModifyBg })}>
										<td className="padding-left-60 width-600" colSpan={2}>
											<div className="display-flex">
												<Link to={`campaigns/${sp.campaign_id}/payout-editor`} className="display-flex width-300">
													Camp. id {sp.campaign_id}; Geo {sp.campaign_country}
												</Link>
												{`      `}
												<span className='padding-left-60'>{sp.sid_type || 'sid'} ({sp.sid})</span>
											</div>
										</td>
										<td className="text-right">{sp[`${sp.campaign_currency}_amount`]} {sp.campaign_currency}</td>
										<td colSpan={3}></td>
									</tr>);
								}
							}
						}

						// targeting row
						shouldShowTarget && res.push(
							<FieldArray
								name={`${parentName}.targets`}
								intl={props.intl}
								can={props.can}
								isMaster={props.isMaster}
								filters={props.filters}
								offer={get(fields.getAll()[index], 'offer')}
								offers={props.offers}
								payoutMatrix={props.payoutMatrix}
								removeCampaignPayout={props.removeCampaignPayout}
								defaultTerms={props.defaultTerms}
								campaignPayouts={props.campaignPayouts}
								parentIndex={index}
								onTermsResetToDefault={props.termsResetToDefault}
								getCampaignData={props.getCampaignData}
								payoutCurrencies={props.payoutCurrencies}
								nullifiedBoosts={props.nullifiedBoosts}
								indTermsNullifyBoostOnSubmit={props.indTermsNullifyBoostOnSubmit}
								component={Targets} />
						);

						return res;
					})).reverse() }
				</tbody>
			</table>
		)}
	</div>
);

Form.propTypes = {
	handleSubmit: PropTypes.func,
	termsFormSubmit: PropTypes.func,
	intl: PropTypes.func
};

RenderFieldArray.propTypes = {
	fields: PropTypes.object,
	intl: PropTypes.func,
	offersLookups: PropTypes.func,
	removeTerms: PropTypes.func,
	termsResetToDefault: PropTypes.func,
	nullifiedBoosts: PropTypes.array,
	indTermsNullifyBoostOnSubmit: PropTypes.func
};

// functions
const shouldDisabledAddField = fields => {
	if (!fields) return true;
	return !!find(fields, entity => isEmpty(entity));
};

const handleTermsShowTarget = (entity, onShowTermsPane, onFetchDefaultTarget) => (index) => {
	const offer = entity.offer[0];
	onFetchDefaultTarget(index, offer, true);
};

const highlightOfferWithIndividualTerms = offer => {
	return some(offer.targets, target => {
		return target.is_individual_term || target.boost_till;
	});
};

export default connect(state => ({
	isCommentFormVisible: state.affiliateProfile.individualTermsForm.isCommentFormVisible,
	payoutCurrencies: state.root.lists['payout-currencies'].map(currency => currency.id),
	isSubmitDisabled: state.affiliateProfile.individualTermsForm.isSubmitDisabled
}))(reduxForm({
	form: 'affiliateIndividualTermsForm'
})(Form));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/affiliates/components/profile/forms/individual-terms/main.js